import { Award, Shield, MapPin, CheckCircle2 } from "lucide-react";

const ABOUT_IMG = "https://images.pexels.com/photos/7587882/pexels-photo-7587882.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=900";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-background">
      <div className="container-ic">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="Ironclad landscaping work"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-primary/20" />
            </div>
            <div className="mt-6 border border-border p-6 bg-card">
              <div className="flex items-center gap-3">
                <Shield className="h-5 w-5 text-primary" />
                <span className="font-display text-lg font-bold uppercase tracking-wider">
                  Veteran Owned Business
                </span>
              </div>
              <p className="mt-2 text-sm text-muted-foreground">
                Proudly serving our communities with the same discipline we served our
                country.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="overline mb-4">About Ironclad</div>
            <h2 className="font-display text-4xl md:text-6xl font-black uppercase tracking-tighter leading-[0.95]">
              Protecting your yard
              <br />
              <span className="text-primary">the ironclad way.</span>
            </h2>
            <p className="mt-6 text-muted-foreground text-lg leading-relaxed max-w-2xl">
              Ironclad Yard Services is veteran owned and operated, rooted in Central
              Texas. We care for lawns across the Greater San Antonio area with precision,
              pride, and a steady hand. The same disciplined crew shows up every time,
              delivering the Ironclad standard your property can count on — and your
              yard deserves nothing less.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                "Disciplined, reliable crews",
                "Transparent flat pricing",
                "10% discount for fellow veterans",
                "Flexible weekly or bi-weekly scheduling",
                "Locally owned — we answer our phone",
                "Free estimates, always",
              ].map((f, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 border border-border p-4 bg-card/40"
                  data-testid={`about-feature-${i}`}
                >
                  <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-foreground">{f}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap gap-8">
              <div>
                <Shield className="h-5 w-5 text-primary mb-2" />
                <div className="font-display text-3xl font-bold">Vet</div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">
                  Owned
                </div>
              </div>
              <div>
                <MapPin className="h-5 w-5 text-primary mb-2" />
                <div className="font-display text-3xl font-bold">4</div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">
                  Cities Served
                </div>
              </div>
              <div>
                <Award className="h-5 w-5 text-primary mb-2" />
                <div className="font-display text-3xl font-bold">10%</div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">
                  Veteran Discount
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
